import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
// import { LocationStrategy, PathLocationStrategy } from '@angular/common' ;
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { IonicStorageModule } from '@ionic/storage';
import { AppConfig } from '../providers/appconfig';
import { GMRIUnits } from '../providers/appconfig';
import { InundationProvider } from '../providers/inundation-provider';
import { WaterlevelProvider } from '../providers/waterlevel-provider';
import { WaveProvider } from '../providers/wave-provider';
import { WebServiceProvider } from '../providers/webservice-provider';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HttpModule} from '@angular/http';
import { JsonpModule} from '@angular/http';
import { DatePipe } from '@angular/common';
import 'intl';
import 'intl/locale-data/jsonp/en';
import { MapProvider } from '../providers/map/map';
// import { ChartModule } from 'angular2-highcharts';
// import * as highcharts from 'highcharts';

// declare var require : any;
@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {}, 
{
  links: [
    { loadChildren: '../pages/asset-map/asset-map.module#AssetMapPageModule', name: 'AssetMapPage', segment: 'asset-map', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/error/error.module#ErrorPageModule', name: 'ErrorPage', segment: 'error', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/filter-page/filter-page.module#FilterPageModule', name: 'FilterPage', segment: 'filter-page', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/home/home.module#HomePageModule', name: 'HomePage', segment: 'home', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/inundation-about/inundation-about.module#InundationAboutPageModule', name: 'InundationAboutPage', segment: 'inundation-about', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/inundation-data/inundation-data.module#InundationDataPageModule', name: 'InundationDataPage', segment: 'inundation-data', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/inundation-details/inundation-details.module#InundationDetailsPageModule', name: 'InundationDetailsPage', segment: 'inundation-details', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/inundation-examples/inundation-examples.module#InundationExamplesPageModule', name: 'InundationExamplesPage', segment: 'inundation-examples', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/inundation-graph/inundation-graph.module#InundationGraphPageModule', name: 'InundationGraphPage', segment: 'inundation-graph', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/inundation-tabs/inundation-tabs.module#InundationTabsPageModule', name: 'InundationTabsPage', segment: 'inundation-tabs', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/layer-picker/layer-picker.module#LayerPickerPageModule', name: 'LayerPickerPage', segment: 'layer-picker', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/tide-about/tide-about.module#TideAboutPageModule', name: 'TideAboutPage', segment: 'tide-about', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/tide-details/tide-details.module#TideDetailsPageModule', name: 'TideDetailsPage', segment: 'tide-details', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/tide-examples/tide-examples.module#TideExamplesPageModule', name: 'TideExamplesPage', segment: 'tide-examples', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/tide-graph/tide-graph.module#TideGraphPageModule', name: 'TideGraphPage', segment: 'tide-graph', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/tide-tabs/tide-tabs.module#TideTabsPageModule', name: 'TideTabsPage', segment: 'tide-tabs', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/wave-about/wave-about.module#WaveAboutPageModule', name: 'WaveAboutPage', segment: 'wave-about', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/wave-data/wave-data.module#WaveDataPageModule', name: 'WaveDataPage', segment: 'wave-data', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/wave-details/wave-details.module#WaveDetailsPageModule', name: 'WaveDetailsPage', segment: 'wave-details', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/wave-examples/wave-examples.module#WaveExamplesPageModule', name: 'WaveExamplesPage', segment: 'wave-examples', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/wave-graph/wave-graph.module#WaveGraphPageModule', name: 'WaveGraphPage', segment: 'wave-graph', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/wave-tabs/wave-tabs.module#WaveTabsPageModule', name: 'WaveTabsPage', segment: 'wave-tabs', priority: 'low', defaultHistory: [] }
  ]
}),
    HttpModule,
    JsonpModule,
    IonicStorageModule.forRoot()
    // ChartModule.forRoot(highcharts)
    // ChartModule.forRoot(require('highcharts/highstock'))
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    StatusBar,
    SplashScreen,
    AppConfig,
    GMRIUnits,
    InundationProvider,
    WaterlevelProvider,
    WaveProvider,
    DatePipe,
    WebServiceProvider,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    MapProvider
    // {provide: LocationStrategy, useClass: PathLocationStrategy}
  ]
  // schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts